import styled from "styled-components/macro";

export const Header = styled.p`
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 10px;
`;
